<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_viii"></a>CONTENTS</p>
<p class="toc"><a href="#/html/9780226112398_06_pre">Preface</a></p>
<p class="toc1"><a href="#/html/9780226112398_07_int">Guide to Cat Musculature: A Photographic Atlas</a></p>
<p class="toc-chap"><span href="#/html/9780226112398_08_ch1" title="Link target outside of Sample">Plates</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226112398_05_toc.vue?387d3ea0